import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import { useDispatch, useSelector } from 'react-redux';
import { useLocalisation } from '@3plearning/lingui-cdn';

import css from './attempt-item.scss';

import { setAssignmentResultsType } from '../../assignment-result-actions';
import { ASSIGNMENT_RESULT_TYPES } from '../../assignment-result-reducer';

const AttemptItem = ({ type }) => {
    const { i18n } = useLocalisation();
    const dispatch = useDispatch();
    const assignmentResultsType = useSelector(
        (state) => state.assignmentResultType
    );

    const { HIGHEST, TEACHER_ASSIGNED, VOLUNTARY } = ASSIGNMENT_RESULT_TYPES;
    const ASSIGNMENT_ITEM_TEXT = {
        [HIGHEST]: {
            label: i18n._(t`Assignment Item - All highest - Label`),
            tooltip: i18n._(t`Assignment Item - All highest - Tooltip`)
        },
        [TEACHER_ASSIGNED]: {
            label: i18n._(t`Assignment Item - Teacher assigned - Label`),
            tooltip: i18n._(t`Assignment Item - Teacher assigned - Tooltip`)
        },
        [VOLUNTARY]: {
            label: i18n._(t`Assignment Item - Voluntary attempt - Label`),
            tooltip: i18n._(t`Assignment Item - Voluntary attempt - Tooltip`)
        }
    };
    const selectedText = ASSIGNMENT_ITEM_TEXT[type];

    function getButtonClassname() {
        const isActive = assignmentResultsType === type;

        return `${css['attempt-button']} ${isActive && css.active}`;
    }
    function getTooltipClassname() {
        const typeSelector = `type-${type}`;

        return `${css.tooltip} ${css[typeSelector]}`;
    }

    return (
        <div className={css['attempt-item']}>
            <div
                tabIndex={0}
                role={'button'}
                className={getButtonClassname()}
                onClick={() => dispatch(setAssignmentResultsType(type))}
            >
                {selectedText.label}
            </div>
            <div className={css['attempt-info-button-container']}>
                <div className={css['attempt-info-button']} />
                <div className={getTooltipClassname()}>
                    {selectedText.tooltip}
                </div>
            </div>
        </div>
    );
};

AttemptItem.propTypes = {
    type: PropTypes.oneOf(Object.values(ASSIGNMENT_RESULT_TYPES))
};

export default styleable(css)(AttemptItem);



// WEBPACK FOOTER //
// ./components/assignment-result/components/attempt-item/attempt-item.js